import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { paths } from '@/constants/paths'
import { slugs } from '@/constants/slugs'
import { useTranslate } from '@/utils/translate/translate-client'
import { AsSpan, ParagraphSM } from '../Text'

interface BreadcrumbProps extends HTMLAttributes<HTMLElement> {
  projectSlug: string
  projectName: string
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ className, projectSlug, projectName }) => {
  const { t } = useTranslate('common')

  return (
    <div className={classNames('line-clamp-1 pl-4', className)}>
      <InternalLink href={`${paths.watch.index}/${projectSlug}`}>
        <CaretLeftIcon className="mr-2 inline" color="white" />
      </InternalLink>
      <ParagraphSM className="text-white" as={AsSpan}>
        <InternalLink href={paths.watch.index}>{t('watch', 'Watch')}</InternalLink>
      </ParagraphSM>
      {projectSlug !== slugs.forYourConsideration && (
        <>
          <ParagraphSM className="mx-2 text-gray-600" as={AsSpan}>
            /
          </ParagraphSM>
          <ParagraphSM className="text-white" as={AsSpan}>
            <InternalLink href={`${paths.watch.index}/${projectSlug}`}>{projectName}</InternalLink>
          </ParagraphSM>
        </>
      )}
    </div>
  )
}
